import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/pro-solid-svg-icons";
import { withTranslation } from "react-i18next";

import MainLayout from "../../../layout";

import "./index.scss";

const ThankYouScreen = ({ t, onStartOver }) => {
  setTimeout(() => {
    onStartOver();
  }, 8000);

  const content = (
    <div className="ThankYouScreen">
      <div className="KeyLockerTitle">
        <FontAwesomeIcon icon={faThumbsUp} className="ThankYouIcon" />
        {t("kl_thank_you").message || "Thank You"}
      </div>
      <div className="ThankYouMessage">{t("kl_we_will_contact_you_soon").message || "We will contact you soon"}</div>
    </div>
  );

  return <MainLayout content={content} />;
};

export default withTranslation()(ThankYouScreen);
